import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-xl font-semibold mb-4" }
const _hoisted_2 = { class: "text-2xl font-bold mb-4" }
const _hoisted_3 = { class: "text-sm text-gray-600 mb-4" }
const _hoisted_4 = { class: "space-y-3 mb-6" }
const _hoisted_5 = { class: "text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col p-6 bg-white rounded-lg shadow-sm border transition-all duration-200", [
      _ctx.isSelected ? 'border-primary-purple border-2' : 'border-gray-200 border',
    ]])
  }, [
    _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.plan.name), 1),
    _createElementVNode("div", _hoisted_2, "$" + _toDisplayString(_ctx.monthlyCharge(_ctx.plan)) + "/mo", 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.plan.payoutFeePercentage) + "% payout fee ", 1),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan.features, (feature) => {
        return (_openBlock(), _createElementBlock("li", {
          key: feature,
          class: "flex items-start text-left"
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-green-500 mr-2" }, "✓", -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(feature), 1)
        ]))
      }), 128))
    ]),
    _createVNode(_component_BaseButton, {
      class: _normalizeClass(["w-full mt-auto py-2 rounded-md transition-colors duration-200", [
        _ctx.isSelected
          ? 'bg-primary-purple text-white hover:bg-purple-700'
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200',
      ]]),
      onClick: _ctx.handleButtonClick
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
      ]),
      _: 1
    }, 8, ["class", "onClick"])
  ], 2))
}